/**
 * 回答ステータス
 * @enum {number}
 * @readonly
 * @property {number} TEMPORARILY_SAVED - 回答前
 * @property {number} SUBMITTED - 未評価
 * @property {number} SCORE_RATED - 評価済
 */
export const AnswerStatusEnum = {
  TEMPORARILY_SAVED: 1,
  SUBMITTED: 2,
  SCORE_RATED: 3,
} as const

/**
 * 回答ステータスの列挙型
 */
export type AnswerStatus =
  (typeof AnswerStatusEnum)[keyof typeof AnswerStatusEnum]

export const getAnswerStatusText = (status: number): string => {
  switch (status) {
    case AnswerStatusEnum.TEMPORARILY_SAVED:
      return '回答前'
    case AnswerStatusEnum.SUBMITTED:
      return '未評価'
    case AnswerStatusEnum.SCORE_RATED:
      return '評価済'
    default:
      return '終了済'
  }
}

export const isAnsweredAnswerStatus = (
  answerStatus: AnswerStatus,
): boolean => {
  const answeredStatuses: AnswerStatus[] = [
    AnswerStatusEnum.SUBMITTED,
    AnswerStatusEnum.SCORE_RATED,
  ]
  return answeredStatuses.includes(answerStatus)
}

export const isUnansweredAnswerStatus = (
  answerStatus: AnswerStatus | undefined,
): boolean => {
  return (
    answerStatus === undefined || !isAnsweredAnswerStatus(answerStatus)
  )
}
